import mergeDeep from "../../../util/mergeDeep.js";

export default class AndereOpmerkingenPageHelper {

    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        let context = this.context;
        context.props.loadLayout("Meld nieuwe sportclub");

        context.setState({
            model: context.props.storeModel
        });
    }

    goToNext() {
        this.redirector.goTo("/nieuweSportclub/bevestiging");
    }

    goToPrev() {
        this.redirector.goTo("/nieuweSportclub/socialemedia");
    }

    change(event) {
        const value = event.target.value;
        const property = event.target.name;
        let context = this.context;

        let model = mergeDeep({}, context.state.model);
        model[property] = value;

        this.context.setState({
            model,
            andereOpmerkingHasFocus: false
        });
    }
}